class LatestWork {
    constructor() {
        this.projects = [
            {
                title: 'Solina',
                description: "Grand groupe de l'agro-alimentaire.",
                image: '/Images/projet_Solina.png',
                link: '/solina.html'
            },
            {
                title: 'Canal 55',
                description: 'Agence dans le domaine du médical et de la beauté.',
                image: '/Images/Photos_elwwod.png',
                link: '/elwood.html'
            },
            {
                title: 'Lord Anthony Cahn',
                description: 'Artiste sculpteur street art.',
                image: '/Images/photo_antho.jpg',
                link: '/lord-anthony-cahn.html'
            },
            {
                title: 'Photos',
                description: 'Travaux personnels.',
                image: '/Images/photo_dublin.jpg',
                link: '/photos.html'
            }
        ]
        
        this.createHTML()
    }

    createHTML() {
        // Create main section
        const section = document.createElement('section')
        section.className = 'latest-work-section'
        section.id = 'latest-work'

        // Create title
        const title = document.createElement('h2')
        title.className = 'latest-work-title'
        title.textContent = 'LATEST WORK'
        section.appendChild(title)

        // Create project cards for each project
        this.projects.forEach((project) => {
            const card = this.createProjectCard(project)
            section.appendChild(card)
        })

        // Add to content wrapper
        const contentWrapper = document.querySelector('.content-wrapper') || document.body
        contentWrapper.appendChild(section)

        this.section = section
    }

    createProjectCard(project) {
        // Create project card
        const card = document.createElement('div')
        card.className = 'project-card'
        card.style.cursor = 'pointer'

        // Card header
        const header = document.createElement('div')
        header.className = 'project-header'

        const projectTitle = document.createElement('h3')
        projectTitle.className = 'project-title'
        projectTitle.textContent = project.title

        // Add description if it exists
        const description = document.createElement('p')
        description.className = 'project-description'
        description.textContent = project.description

        const linkButton = document.createElement('a')
        linkButton.href = project.link
        linkButton.className = 'project-link-btn'
        linkButton.setAttribute('aria-label', 'Open project')
        linkButton.innerHTML = `
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M7 17L17 7M17 7H7M17 7V17"/>
            </svg>
        `

        header.appendChild(projectTitle)
        if (project.description) {
            header.appendChild(description)
        }
        header.appendChild(linkButton)

        // Card content (image)
        const imageContainer = document.createElement('div')
        imageContainer.className = 'project-image-container'

        const image = document.createElement('img')
        image.src = project.image
        image.alt = project.title
        image.className = 'project-image'
        image.loading = 'lazy'

        imageContainer.appendChild(image)

        // Assemble card
        card.appendChild(header)
        card.appendChild(imageContainer)

        // Make entire card clickable
        card.addEventListener('click', (e) => {
            // Navigate to the link
            window.location.href = project.link
        })

        return card
    }

    updateVisibility(scrollY) {
        // Empty - section is always visible
    }
}

export default LatestWork
